import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Pizza, Clock } from "lucide-react";

export default function VerifyPage() {
  const [params] = useSearchParams();
  const code = params.get("code");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (!code) { setLoading(false); return; }
    api.get(`/verify/${code}`).then((r) => setResult(r.data)).catch(() => setResult({ valid: false })).finally(() => setLoading(false));
  }, [code]);

  const active = result?.valid && result?.active;

  return (
    <div className={`App min-h-screen flex flex-col items-center justify-center text-center px-6 ${active ? "live-bg text-white" : "bg-[#17324D] text-white"}`}>
      {loading ? (
        <p className="font-heading font-bold text-2xl">Verifying...</p>
      ) : !result?.valid ? (
        <>
          <XCircle size={64} className="text-[#D94A3D]" />
          <h1 className="font-heading font-extrabold text-3xl sm:text-4xl mt-4">INVALID CODE</h1>
          <p className="mt-2 opacity-80">This membership card could not be found.</p>
        </>
      ) : active ? (
        <div data-testid="verify-active">
          <span className="inline-flex bg-white text-[#D94A3D] p-4 rounded-full spin-slow mb-4"><Pizza size={48} /></span>
          <CheckCircle2 size={56} className="mx-auto" />
          <h1 className="font-heading font-extrabold text-4xl leading-none mt-2">ACTIVE MEMBER</h1>
          <p className="text-2xl font-serif-ed italic mt-3">{result.name}</p>
          <p className="mt-2 text-lg opacity-90">{result.clubs.join(" · ")}</p>
          <div className="mt-6 flex items-center justify-center gap-2"><Clock size={18} /><span className="font-mono tabular-nums text-lg">{now.toLocaleTimeString()}</span></div>
        </div>
      ) : (
        <div data-testid="verify-inactive">
          <XCircle size={56} className="mx-auto text-[#D94A3D]" />
          <h1 className="font-heading font-extrabold text-3xl sm:text-4xl mt-2">NOT ACTIVE</h1>
          <p className="text-xl mt-2">{result.name} has no active membership.</p>
        </div>
      )}
      {!loading && (
        <div className="absolute bottom-4 left-0 right-0 text-center text-xs opacity-70">
          <Link to="/privacy" className="underline">Privacy</Link> · <Link to="/terms" className="underline">Terms</Link>
        </div>
      )}
    </div>
  );
}
